import { render } from "./CartTable.vue?vue&type=template&id=eda8c57e"
import script from "./CartTable.vue?vue&type=script&lang=js"
export * from "./CartTable.vue?vue&type=script&lang=js"
script.render = render

export default script